import styled from 'styled-components';

export default styled.div`
	&.loading {
		pointer-events: none;
		opacity: 0.4;
	}
	.RelateListContainers {
		overflow: visible;
		gap: var(--gap);
		.StyledTreeViewListHeader {
			display: none;
		}
		.relate-list-toolbar {
			flex-direction: column;
			align-items: normal;
		}
		.HeaderTreeWrapper {
			padding: 0;
		}
		.tree-list-body-wrapper {
			overflow-y: unset;
			.tree-item {
				fill: var(--body--color);
				.tree-item-label-txt {
					flex-grow: 1;
					max-width: unset;
					font-size: var(--px-14);
					.engagement-label {
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						padding-right: var(--spacing-medium);
					}
					.engagement-count {
						margin-left: auto;
					}
				}
			}
			/* OVERRIDE FOR THE EXTRA LINES ON THE TREEVIEW */
			.tree-list-item {
				.tree-item-list-level2,
				.tree-item-list-level3,
				.tree-item-list-level4 {
					.tree-list-item.children-open:last-child:after {
						background-color: ${(props) => props.theme.color['bgGradient1black']};
					}
				}
			}
			/* OVERRIDE FOR THE EXTRA LINES ON THE TREEVIEW */
		}
		/* OVERRIDES DUE TO COLLAPSIBLE SIDEBAR */
		.TreeViewListSearch {
			min-width: unset;
		}
		/* OVERRIDES DUE TO COLLAPSIBLE SIDEBAR */
	}
`;
